(function() {
'use strict';

angular.module('TR')
    .service('destinationService', destinationService);

function destinationService(loggingService,
        objectTypeService,
        pageStrand,
        fieldFilterParser,
        $http,
        $location,
        $q,
        broker,
        imageService,
        supportedProducts,
        currentUser,
        preferences,
        resourceService,
        $cacheFactory,
        rootPath,
        fidParser) {
    const url = `${TRPCONFIG.DestinationServiceClientDomain}/api2/destination/v2/`;
    const cultureCode = TRPCONFIG.Domain.CultureCode;
    const strands = {
        hotel: 1,
        holiday: 2
    };
    const tiles = [];
    const textUrl = `${TRPCONFIG.DestinationServiceClientDomain}${rootPath.getRootPath()}website/destinations/text?`;
    const tileUrl = `${TRPCONFIG.DestinationServiceClientDomain}/api2/destination/tiles/`;
    const tileImageUrl = `${TRPCONFIG.DestinationImagesClientDomain}/api2/destination/images/`;
    const websiteUrl = 'website/destinations/';
    const airportCache = $cacheFactory.get('airports') || $cacheFactory('airports');
    const service = {
        country: 0,
        estab: 1,
        region: 2,
        getDetails,
        getTopChildren,
        getAllChildren,
        fromUrl,
        destinationIsEstab,
        destinationIsCountry,
        destinationThumb,
        getDestinationType,
        getBreadcrumbTitle,
        isHoliday,
        getText,
        getAirport,
        getAirportDestination,
        getHeroImage,
        getTiles,
        //getTileImageUrl : getTileImageUrl,
        sortByTitle,
        getCountries,
        enhanceDestinationFromPreferences,
        // isLongHaul,
        enhanceLegacyDestination,
        setFidFromDestinationFilter,
        getAllCountries,
        getDestinationInfo,
        rootPath
    };

    const detailsSearch = {};

    function setFidFromDestinationFilter(destination) {
        const fid = fidParser.parse();
        if (destination.FilterId !== fid) {
            $location.replace();
            $location.search('fid', null);
            if (destination.FilterId > 0) {
                if (destination.LegacyType !== 1 && !TRPCONFIG.Domain.UseIdBasedUrls) {
                    $location.search('fid', destination.FilterId);
                } else if (destination.LegacyType === 1) {
                    $location.search('fid', destination.FilterId);
                }
            }
        }
        return destination;
    }

    function enhanceLegacyDestination(destination) {
        const type = parseInt(destination.LegacyType) || parseInt(destination.Type);
        const id = destination.LegacyId || destination.Id;
        return $q.when({
            PageStrand: destination.PageStrand,
            Type: type,
            Id: id,
            EstablishmentId: type === 1 ? id : 0,
            LocationId: type === 2 ? id : 0,
            ProvinceId: type === 3 ? id : 0,
            CountryId: type === 4 ? id : 0,
            PlaceId: type === 5 ? id : 0,
            PolygonId: type === 10 ? id : 0,
            DestinationId: destination.DestinationId
        });
    }

    function sortByTitle(dests) {
        return _.sortBy(dests, 'Title');
    }

    function getText(dest, errorHandler) {
        const fid = fidParser.parse();
        errorHandler = errorHandler || { ignoreErrors: true };
        errorHandler.cache = true;
        return $http.get(textUrl + $.param({
            ObjectTypeId: objectTypeService.get(dest),
            FilterId: fid || 0,
            PageStrandId: dest.PageStrand,
            DomainId: TRPCONFIG.Domain.DomainId,
            Path: dest.PagePath,
            IsPreview: (dest.IsPreview !== undefined && dest.IsPreview === true),
            v: TRPCONFIG.CurrentVersion
        }), errorHandler).then(function(result) {
            result.data.PageTitle = resourceService.getDeferred(result.data.PageTitle)();
            return result.data;
        });
    }

    function getTiles(req) {
        if (tiles[req.ControlId]) {
            return tiles[req.ControlId];
        }

        tiles[req.ControlId] = $http.get(`${tileUrl}get?${$.param({
            DomainId: TRPCONFIG.Domain.DomainId,
            ControlId: req.ControlId
        })}`, { cache: true, ignoreErrors: true }).then(function(result) {
            const tiles = result.data;
            const baseImageReq = _.constant({
                Height: 600,
                Width: 600
            });

            return tiles.map(tile => {
                const infoTile = _.flowRight(JSON.parse, JSON.parse, JSON.stringify)(tile.TitlePattern);
                infoTile.ImageUrl = getTileImageUrl(_.assignIn(baseImageReq(), {
                    ObjectId: tile.ObjectId,
                    ObjectTypeId: tile.ObjectTypeId
                }));
                infoTile.mainUrl = infoTile.ImageUrl;
                infoTile.thumbUrl = infoTile.ImageUrl;
                return infoTile;
            });
        });

        function getTileImageUrl(req) {
            return `${tileImageUrl}gettileimage?${$.param(req)}`;
        }

        return tiles[req.ControlId];
    }

    function isHoliday(dest) {
        return dest && dest.PageStrand != null && dest.PageStrand === strands.holiday;
    }

    function getDestinationType(dest) {
        if (dest == null) { return service.region; }

        if (destinationIsCountry(dest)) { return service.country; }

        if (destinationIsEstab(dest)) { return service.estab; }

        return service.region;
    }

    function logWarning(apiName, err, params) {
        const utm = currentUser.get().UtmId;
        loggingService.logWarn(`Got back err: ${err.status} for utm ${utm} and userAgent ${navigator.userAgent} for api ${apiName} with params ${params}`);
    }

    function fromUrl(from, tm) {
        return $http.get(`${url}fromurlv2?${$.param({
            PagePath: from,
            DomainId: TRPCONFIG.Domain.DomainId,
            v: TRPCONFIG.CurrentVersion
        })}`, { cache: true, ignoreErrors: true }).then(function(result) {
            if (result.data && tm === '1') {
                result.data.PageStrand = 2;
            }
            if (result.data && result.data.PageStrand > 1 && !supportedProducts.isProductSupported(supportedProducts.products.holidays)) {
                result.data.PageStrand = 1;
            }
            return result.data;
        }, function(err) {
            logWarning('fromUrl', err, from);
            return null;
        });
    }

    function getDestinationInfo(id, type, pagestrand) {
        return $http.get(`${url}getdetailsv2?${$.param({
            CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            PageStrand: pagestrand,
            Id: id,
            Type: type
        })}`
        ).then((result => result.data), (err => {
            logWarning('getdetailsv2', err);
            return null;
        }));
    }

    function destinationIsEstab(dest) {
        if (dest == null) { return false; }
        return dest.EstablishmentId > 0;
    }

    function destinationIsCountry(dest) {
        if (dest == null) { return false; }
        if (dest.Searchable) { return false; }
        if (dest.PolygonId > 0 &&
                dest.TagIds &&
                dest.TagIds.indexOf(1) >= 0) {
                    return true;
                }
        return dest.CountryId > 0 &&
            dest.ProvinceId === 0 &&
            dest.LocationId === 0 &&
            dest.PlaceId === 0 &&
            dest.PolygonId === 0;
    }

    function destinationThumb(dest) {
        const objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);
        return `${tileImageUrl}getfromobject?${$.param(_.assignIn({
            height: 190
        }, objectTypeAndId), { cache: true, ignoreErrors: true })}`;
    }

    function getTopChildren(n, d) {
        const fid = fidParser.parse();
        return $http.get(`${url}gettopchildren?${$.param({
            CountryId: d.CountryId,
            ProvinceId: d.ProvinceId,
            LocationId: d.LocationId,
            PlaceId: d.PlaceId,
            EstablishmentId: d.EstablishmentId,
            PolygonId: d.PolygonId,
            Count: n,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            FilterId: fid || 0,
            PageStrand: d.PageStrand,
            v: TRPCONFIG.CurrentVersion
        })}`, { cache: true, ignoreErrors: true }).then(function(result) {
            // Publish topic with data
            broker.publish('destTopChildrenRetrieved', result.data);
            return result.data;
        });
    }

    function getAllChildren(d) {
        return $http.get(`${url}getallchildren?${$.param(childRequest(d))}`,
                { cache: true, ignoreErrors: true }).then(function(result) {
            return result.data;
        });
    }

    function childRequest(d) {
        const fid = fidParser.parse();
        return _.assignIn(objectTypeService.getObjectTypeAndId(d), {
            CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            FilterId: fid || 0,
            PageStrand: d.PageStrand,
            v: TRPCONFIG.CurrentVersion
        });
    }

    function getAllCountries() {
        return $http.get(`${url}getallchildren?${$.param({ CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            PageStrand: 2,
            Type: 12 })}`,
                { cache: true, ignoreErrors: true }).then(function(result) {
                    return result.data;
                });
    }

    function getBreadcrumbTitle(dest, comparatorFn) {
    // `comparatorFn` example: `(bc) => bc.ObjectTypeId === 1`
        const bcTrail = dest && dest.BreadcrumbTrail;
        let i = bcTrail && bcTrail.length;
        while (i--) {
            const bc = dest.BreadcrumbTrail[i];
            if (comparatorFn(bc)) {
                return bc.Title;
            }
        }
    }

    function getCountryOwnId(dest) {
      const bcTrail = dest && dest.BreadcrumbTrail;
      let i = bcTrail && bcTrail.length;

      if (i > 0) {
        return dest.BreadcrumbTrail[0].ObjectId;
      }
    }

    function getDetails(dest, fieldsFilter, options) {
        if (_.isEmpty(dest)) {
             return $q.when();
        }
        let _isAirport = isAirport(dest);
        let get = isAirport => isAirport ? getDetailsForAirport(dest) : getDetailsForDestination(dest, fieldsFilter, options);

        return $q.when()
            .then(() => get(_isAirport))
            .then(result => result || get(!_isAirport));
    }

    function getDetailsForDestination(dest, fieldsFilter, options) {
        let d = _.assign({}, dest);
        options = options || {};
        if (!d.Type) {
            angular.extend(d, objectTypeService.getObjectTypeAndId(d));
        }

        // eslint-disable-next-line
        if (d.Type == 1 && d.Id && !d.EstablishmentId) {
            d.EstablishmentId = d.Id;
        }

        const ps = options.pageStrandOverride || pageStrand.fromRoute(d);
        const fid = fidParser.parse();

        let params = $.param({
            Type: d.Type,
            Id: d.Id,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            IncludeBreadcrumb: true,
            PageStrand: ps,
            v: TRPCONFIG.CurrentVersion,
            domainId: TRPCONFIG.Domain.DomainId,
            auth: currentUser.get().HardSignedIn,
            filterId: fid || 0
        });
        const filter = fieldFilterParser.parse(fieldsFilter);
        if (filter != null) {
            params += `&${filter}`;
        }
        const key = `${websiteUrl}getdetails?${params}`;

        if (!_.isUndefined(detailsSearch[key])) {
            return detailsSearch[key];
        }

        detailsSearch[key] = $http.get(key, { cache: true, ignoreErrors: true }).then(function(result) {
            if (result.data == null) { return null; }
            d.HolidayEnabled = result.data.HolidayEnabled;
            d.Searchable = result.data.Searchable;
            d.BreadcrumbTrail = result.data.BreadcrumbTrail;
            d.Title = result.data.Title;
            // Last non-hotel breadcrumb text
            d.SummaryTitle = getBreadcrumbTitle(d, bc => bc.ObjectTypeId !== strands.hotel) || d.Title;
            // Hotel name, or `SummaryTitle`
            d.ShortTitle = getBreadcrumbTitle(d, bc => bc.ObjectTypeId === strands.hotel) || d.SummaryTitle;
            d.CountryOwnId = getCountryOwnId(d) || 0;
            d.DestinationAirports = result.data.DestinationAirports;
            d.AirportCount = result.data.AirportCount;
            d.HotelCount = result.data.HotelCount;
            d.Longitude = result.data.Longitude;
            d.Latitude = result.data.Latitude;
            d.ZoomLevel = result.data.ZoomLevel;
            d.IsPOI = result.data.IsPOI;
            d.PagePath = result.data.PagePath;
            d.TagIds = result.data.TagIds;
            d.Price = result.data.Price;
            d.PromoText = result.data.PromoText;
            d.Airports = result.data.Airports;
            d.PageStrand = ps;
            return d;
        }, function(err) {
            logWarning('getDetails', err, key);
            return null;
        });

        return detailsSearch[key];
    }

    function getDetailsForAirport(dest) {
        const d = _.assign({}, dest);
        const airportKey = $.param(d);
        if (!_.isUndefined(detailsSearch[airportKey])) {
            return detailsSearch[airportKey];
        }

        function getAirportCode() {
            const airportCode = d.Code && d.Code.split(',')[0];
            if (airportCode) {
                return $q.when(airportCode);
            }
            const params = d.PolygonId ? { id: d.PolygonId, type: 10 } : { id: d.Id, type: d.Type };
            const url = `${TRPCONFIG.DestinationServiceClientDomain}/api/landingpages/destinations/airports?${$.param(params)}`;
            return $http.get(url, { cache: true, ignoreErrors: true }).then(function(result) {
                const airports = result.data;
                if (airports && airports[0]) {
                    d.Code = _(airports).map(a => a.Code).reduce((memo, a) => `${memo},${a}`);
                    return airports[0].Code;
                }
            }, function(err) {
                logWarning('airports', err, url);
                return $q.when(airportCode);
            });
        }

        function getDestinationIds(airportCode) {
            if (angular.isNumber(d.PolygonId) || !/^[a-zA-Z]{3}$/.test(airportCode)) {
                return $q.when();
            }

            const params = $.param({
                airportCode
            });
            const url = `${TRPCONFIG.DestinationServiceClientDomain}/api2/destination/airports/getdestinationservedbyairport?${params}`;

            return $http.get(url, { cache: true, ignoreErrors: true }).then(function(result) {
                if (result.data == null) {
                    return null;
                }
                d.CountryId = result.data.CountryId;
                d.ProvinceId = result.data.ProvinceId;
                d.LocationId = result.data.LocationId;
                d.PlaceId = result.data.PlaceId;
                d.EstablishmentId = result.data.EstablishmentId;
                d.PolygonId = result.data.PolygonId;
            }, function(err) {
                logWarning('getdestinationservedbyairport', err, url);
                return $q.when();
            });
        }

        return getAirportCode()
            .then(airportCode => getDestinationIds(airportCode))
            .then(() => service.enhanceDestinationFromPreferences(d))
            .then(() => {
                const code = shorten(d.Code, ',');
                if (!d.Title && code) {
                    return getAirport(code).then(airport => {
                        if (airport) {
                            d.Title = shorten(airport.Title, '(');
                            d.ShortTitle = shorten(airport.ShortTitle, '(');
                        }
                    });
                }
            })
            .then(() => {
                d.Title = d.Title || d.ShortTitle || d.SummaryTitle || d.Code || '';
                d.ShortTitle = d.ShortTitle || d.SummaryTitle || shorten(d.Title, ',');
                d.SummaryTitle = d.SummaryTitle || d.ShortTitle;
                d.HolidayEnabled = true;//Because this is a flight search, all destinations will be near an airport.
                d.Searchable = true;
                d.AirportCount = d.Code && d.Code.split(',').length;
                d.BreadcrumbTrail = [{
                    Title: d.Title,
                    //PagePath: '/holidays/gatwick-airport-lgw-west-sussex-united-kingdom.html',
                    ObjectId: d.PolygonId,
                    ObjectTypeId: 10
                }];
                angular.extend(d, objectTypeService.getObjectTypeAndId(d));
                return d;
            });
    }

    function isAirport(d) {
        let isAirport;
        if (d.searchLookupType) {
            isAirport = d.searchLookupType === 'flights';
        } else if (d.PageStrand) {
            isAirport = false;
        } else if (d.Code) {
            isAirport = !angular.isNumber(d.PolygonId) || d.PolygonId > 0;
        } else {
            isAirport = false;
        }
        return isAirport;
    }

    function shorten(title, separator) {
        return (title || '').split(separator)[0];
    }

    function enhanceDestinationFromPreferences(destination) {
        objectTypeService.populateObjectTypeAndId(destination);
        return preferences.get('search').then(preferences => {
            const preferencesDest = preferences && preferences.destination && preferences.destination[0];
            if (preferencesDest && preferencesDest.Id && preferencesDest.Id === destination.Id) {
                _.forEach(['Title', 'Code', 'ShortTitle', 'SummaryTitle', 'icon', 'searchLookupType', 'AirportCount'],
                    key => {
                        if (typeof preferencesDest[key] !== undefined) {
                            destination[key] = preferencesDest[key];
                        }
                    });
            }
            return destination;
        });
    }

    function getAirport(airportCode) {
        const k = `${airportCode}_${TRPCONFIG.Domain.CultureCode}`;
        if (!airportCache.get(k)) {
            airportCache.put(
                k,
                $http.post('/api2/flights/static/getairport', {
                    AirportCode: airportCode,
                    CultureCode: TRPCONFIG.Domain.CultureCode
                }, {
                    ignoreErrors: true
                })
                .then(result => result.data.Airport, angular.noop));
        }
        return airportCache.get(k);
    }

    function getAirportDestination(airportCode) {
        const params = {
            airportCode,
            cultureCode: TRPCONFIG.Domain.CultureCode
        };
        return $http.get(
            `/api2/destination/airports/getairportlocation?${$.param(params)}`,
            { ignoreErrors: true }
        ).then(result => {
            return result.data;
        });
    }

    function getHeroImage(destination) {
        return imageService.getLandingPageImage(destination);
    }

    function getCountries() {
        return $http.get(`/api2/destination/countries/get?CultureCode=${cultureCode}`, { cache: true, ignoreErrors: true }).then(function(res) {
            return res.data;
        });
    }

    // function isLongHaul(destination) {
    //     return _.includes(destination && destination.TagIds, 12)
    //         ? $q.when(true)
    //         : $http.get(`/api/destinations/${destination.Id}/ancestors?${$.param({
    //             tenantId: TRPCONFIG.Domain.TenantId,
    //             pointOfSaleId: TRPCONFIG.Domain.PointOfSaleId,
    //             culture: TRPCONFIG.Domain.CultureCode,
    //             fields: 'Tags'
    //         })}`, { cache: true }).then(result =>
    //             _.chain(result.data)
    //                 .flatMap(ancestor => ancestor.Tags)
    //                 .includes(12)
    //                 .value());
    // }

    return service;
}
})();
